import { render, staticRenderFns } from "./HUD.vue?vue&type=template&id=4f5f6e22&scoped=true&"
import script from "./HUD.vue?vue&type=script&lang=ts&"
export * from "./HUD.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5f6e22",
  null
  
)

export default component.exports